export class Menu {

     /*
	 * Init the handler
	 */
    constructor() {

        // Store values
        this.languageMenu = document.getElementById('masthead-language-switcher')
        this.header = document.getElementsByTagName('header')[0];
        this.languageBtns = document.querySelectorAll('.navbar--mobile .language-nav');

        this.menuToggleBtns = document.querySelectorAll('.toggleButton');

		this.countryScrollArrow = document.querySelector('p.compliance-country-header__view-update-link')
        this.lastScrollTop = 0;




        // Setup event listeners
		this.languageMenu.addEventListener('click', this.languageMenuStatus.bind(this));


        this.menuToggleBtns.forEach(element => {
            element.addEventListener('click', this.toggleSubMenu.bind(this, element));
        });
        document.addEventListener('scroll', this.toggleStickyNav.bind(this));
		window.addEventListener('load', this.toggleStickyNav.bind(this));
		window.addEventListener('load', this.countryScroll.bind(this));
        document.querySelector('button.navbar-toggler').addEventListener('click', this.toggleMobileMenu.bind(this));
    }

	countryScroll() {
		if (this.countryScrollArrow instanceof window.HTMLElement) {
			const el = document.querySelector('div.compliance-country-latest__section');

			if(el instanceof window.HTMLElement){
				this.countryScrollArrow.addEventListener('click', function () {

					const yOffset = 105;
					const y = el.getBoundingClientRect().top + window.pageYOffset - yOffset;
					window.scrollTo({top: y, behavior: 'smooth'});
				});
			}
		}
	}


    /**
	 * Toggles langauge selector on mobile
	 *
	 * @return    {void}
	 */
    languageMenuStatus() {

        const activeClass = 'language-menu-open';
        const alreadyOpen = document.body.classList.contains(activeClass);
        if (!alreadyOpen) {
			document.body.classList.add(activeClass);
		} else {
            document.body.classList.remove(activeClass);
        }
    }

    /**
	 * Toggles sticky nav on scroll. Hides nav afer 150px scroll. Shows nav on scroll up.
	 *
	 * @return    {void}
	 */
    toggleStickyNav() {
		const el = document.querySelector('header.header-classic');
		const target = document.querySelector('body');
		const observer = new IntersectionObserver(
			([e]) =>
				target.classList.toggle('is-sticky', e.intersectionRatio < 1),
			{ threshold: [1] }
		);
		observer.observe(el);
    }

     /**
	 * Toggles mobile menu.
	 *
	 * @return    {void}
	 */
    toggleMobileMenu() {
        const activeClass = 'mobile-menu-open';
        const alreadyOpen = document.body.classList.contains(activeClass);
        if (!alreadyOpen) {
			document.body.classList.add(activeClass);
		} else {
            document.body.classList.remove(activeClass);
        }
    }


    /**
	 * Toggles mobile menu sub menus.
	 *
	 * @return    {void}
	 */
    toggleSubMenu(element) {
        let subMenu = element.nextElementSibling;
        if (subMenu.classList.contains('d-block')) {

            this.menuToggleBtns.forEach(btn => btn.classList.remove('toggleButton--active'));
            document.querySelectorAll('.sub-menu').forEach(menu => menu.classList.remove('d-block'));
        } else {
            document.querySelectorAll('.sub-menu').forEach(menu => menu.classList.remove('d-block'));
            this.menuToggleBtns.forEach(btn => btn.classList.remove('toggleButton--active'));

            if (!element.classList.contains('toggleButton--active')) {
                element.classList.add('toggleButton--active');
            } else {
                element.classList.remove('toggleButton--active');
            }

            if (!subMenu.classList.contains('d-block')) {
                subMenu.classList.add('d-block');
            } else {
                subMenu.classList.remove('d-block');
            }
        }
	}
}





